import { writable } from "svelte/store";

/**
 * "This page needs a scale before the thing you just asked for can happen."
 * Document.svelte sets it as a frame placement aborts; Step 2 sets it when Find
 * Frames is pressed with an unscaled page selected. Step1Scale opens the scale
 * flow and clears it.
 *
 * `note` is optional, so Document.svelte's `{ pageId }` keeps working untouched;
 * it overrides the modal's explanatory line for callers other than placement.
 * @type {import("svelte/store").Writable<{ pageId: string, note?: string } | null>}
 */
export const forceScaleFor = writable(null);
